enum method {
    toLocaleString = 'toLocaleString',
    toLocaleDateString = 'toLocaleDateString',
    toLocaleTimeString = 'toLocaleTimeString',
}

function checkSupport(methodName: method): boolean {
    try {
        new Date()[methodName](navigator.language);

        return true;
    } catch (e) {
        return false;
    }
}

export function checkToLocaleStringSupport(): boolean {
    return checkSupport(method.toLocaleString);
}

export function checkToLocaleDateStringSupport(): boolean {
    return checkSupport(method.toLocaleDateString);
}

export function checkToLocaleTimeStringSupport(): boolean {
    return checkSupport(method.toLocaleTimeString);
}
